<template>
  <div
    class="header unselectable"
    :style="headerStyle"
  >
    <span :class="alignIcons" style="align:right">           
    <PsImageTooltip :text="ellipsisButtonToolTipText">        
        <PsIconButton
          v-if="showEllipsisButton"
          small
          :mouseout="emitMouseOut"
          :click="emitEllipsisEvent"
          icon="cog"
        />
    </PsImageTooltip>

      <PsImageTooltip :text="addButtonToolTipText">
        <PsIconButton
          v-if="showAddButton"
          small
          :mouseout="emitMouseOut"
          :click="emitAddEvent"
          icon="add"
        />
      </PsImageTooltip>

      <PsImageTooltip :text="refreshButtonToolTipText">
        <PsIconButton
          v-if="showRefreshButton"
          small
          :mouseout="emitMouseOut"
          :click="emitRefreshEvent"
          icon="refresh"
        />
      </PsImageTooltip>

      <PsImageTooltip :text="saveButtonToolTipText">
        <PsIconButton
          v-if="showSaveButton"
          small
          :mouseout="emitMouseOut"
          :click="emitSaveEvent"
          icon="save"
        />
      </PsImageTooltip>
      
      <PsImageTooltip :text="uploadButtonToolTipText">
        <PsIconButton
            v-if="showUploadButton"
            small
            :mouseout="emitMouseOut"
            :click="emitUploadEvent"
            icon="upload"
        />
      </PsImageTooltip>

      <PsImageTooltip :text="excelButtonToolTipText">
          <PsIconButton 
            v-if="showExcelButton"
            small
            :mouseout="emitMouseOut"
            :click="emitExcelEvent"
            icon="excel"
          />
      </PsImageTooltip>

      <PsImageTooltip :text="navigateBackToolTipText">   
        <!-- This nbsp; is intentionally here to replicate the same spacing as back arrows in P3 screens -->
        &nbsp;
        <PsIconButton
        v-if="showBackButton"
        small
        :mouseout="emitMouseOut"
        :click="emitNavigateBackEvent"
        icon="arrow_back"
      />
    </PsImageTooltip>

      <PsImageTooltip :text="frozenHeadersButtonToolTipText">
          <PsIconButton 
            v-if="showFrozenHeadersButton"
            small
            :mouseout="emitMouseOut"
            :click="emitFrozenHeadersEvent"
            icon="freeze_bold"
          />
      </PsImageTooltip>

      <span> {{ headerTitle }} &nbsp;</span>
      
      <PsTimePeriodNav 
        v-if="showTimePeriodNav"
      />

      <PsIconButton
        v-if="showCheckButton"
        small
        :click="emitCheckEvent"
        icon="check"
        style="color: #57d457;"
      /> 

      <PsIconButton
        v-if="showCloseButton"
        small
        :click="emitCloseEvent"
        icon="close"
        class="align-center rightReport"
        style="color:red"
      />
    </span>
    <slot />
    <span
      v-if="showSearchBar"
      class="align-center rightReport"
    >
     <PsSearchBox
        v-if="showTextField"
        id="searchP4" 
        :ref="'searchP4-' + widgetid"
        v-model="search"
        class="searchP4"
        :show="displaySearch"
      />
      <button
        id="searchClearButton"
        :ref="'searchClearButton-' + widgetid"
        @click.prevent="clearSearchText"
      >
        x
      </button> 
    </span>
    <span v-if="showOrbitalMenu">       
        <PsOrbitalMenu />
    </span>
  </div>
</template>
<script>
import PsOrbitalMenu from './ps-orbital-menu.vue';
import PsSearchBox from "./ps-searchbox";
function debounce(fn, delay) {
    var timeoutID = null;
    return function() {
        clearTimeout(timeoutID);
        var args = arguments;
        var that = this;
        timeoutID = setTimeout(function() {
            fn.apply(that, args);
        }, delay);
    };
}
export default {
    name: "PsReportHeader",
    components:{
        PsSearchBox,
        PsOrbitalMenu
    },
    props: {
        showOrbitalMenu: {
            type: Boolean,
            default: false
        },
        saveButtonToolTipText:{
            type: String,
            default: "Save"
        },
        refreshButtonToolTipText:{
            type: String,
            default: "Refresh"
        },
        addButtonToolTipText:{
            type: String,
            default: "Add"
        },
        navigateBackToolTipText:{
            type: String,
            default: "Back"
        },
        ellipsisButtonToolTipText:{
            type:String,
            default: "Options"
        },
        uploadButtonToolTipText:{
            type:String,
            default: "Upload File"
        },
        excelButtonToolTipText:{
            type:String,
            default: "Download Excel File"
        },
        frozenHeadersButtonToolTipText:{
            type: String,
            default: "Toggle Frozen Headers"
        },
        widgetid: {
            type: String,
            default: ""
        },
        alignIcons: {
            type: String,
            default: "leftReport"
        },
        headerWidth: {
            type: String,
            default: ""
        },
        headerTitle: {
            type: String,
            default: ""
        },
        showFrozenHeadersButton: {
            type: Boolean,
            default: false
        },
        navMenuID:{
            type: Number,
            default:-1
        },
        showEllipsisButton: {
            type: Boolean,
            default: false
        },
        showSearchBar: {
            type: Boolean,
            default: true
        },
        showAddButton: {
            type: Boolean,
            default: true
        },
        showCloseButton: {
            type: Boolean,
            default: false
        },
        showTimePeriodNav: {
            type: Boolean,
            default: false
        },
        addButtonUrl: {
            type: String,
            default: "#"
        },
        showBackButton: {
            type: Boolean,
            default: false
        },
        showSaveButton: {
            type: Boolean,
            default: true
        },
        showCheckButton: {
            type: Boolean,
            default: false
        },
        showRefreshButton: {
            type: Boolean,
            default: true
        },
        showUploadButton: {
            type: Boolean,
            default: null
        },
        showExcelButton: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            search: "",
            debouncedSearch: "",
            displaySearch: true,
            searchBoxIsEmpty: true,
            showUploadButton:null,
        };
    },
    computed: {
        headerStyle() {
            return "width: " + this.headerWidth + "px !important;text-align:right;padding-right:30px;";
        }
    },
    watch: {
        search: function(newVal) {
            var xButton = this.$refs["searchClearButton-" + this.widgetid];
            xButton.style.display = "block";

            if(newVal.length === 0)
            {
                this.searchBoxIsEmpty = true;
                xButton.style.display = "none";               
                this.clearSearchText();
                this.$emit("search-event", this.debouncedSearch);
                return;
            }
            this.searchBoxIsEmpty = false;
            this.debouncedSearch = newVal;           
            this.$emit("search-event", this.debouncedSearch);
        }
    },
    mounted() {
        if(this.showUploadButton == null){
            this.showUploadButtonVisibility();
        }

        window.Bus.$off("hideOrbitalMenu");
        window.Bus.$on("hideOrbitalMenu", () => {
            $(".circle").hide();
        });

        window.Bus.$off("showOrbitalMenu");
        window.Bus.$on("showOrbitalMenu", () => {
            $(".circle").show();
        });

        var inputElement = this.$refs["searchP4-" + this.widgetid];

        var searchBox = {};

        if(inputElement === undefined) {
            return;
        }

        if(inputElement !== undefined)
        {
            var elms = inputElement.$el.getElementsByTagName("*");
            for (var i = 0; i < elms.length; i++) {
                if(elms[i].tagName === "INPUT" && elms[i].id === "searchP4")
                {
                    searchBox = elms[i];
                }
            }
        }
        
        searchBox.addEventListener("blur", (event) => {
            if(this.searchBoxIsEmpty === true)
            {
                if(searchBox !== null)
                {                   
                    searchBox.classList.remove("searchfocus");
                    searchBox.id = "searchP4";
                    var xButton = this.$refs["searchClearButton-" + this.widgetid];
                    xButton.style.display = "none";
                }
            }

            if(this.searchBoxIsEmpty === false)
            {
                if(searchBox !== null)
                {
                    if(searchBox.id !== "searchNonEmpty")
                    {
                        searchBox.id = "searchNonEmpty";
                        searchBox.classList.add("searchfocus");
                        var xButton = this.$refs["searchClearButton-" + this.widgetid];
                        xButton.style.display = "block";
                    }                  
                }                
            }
        });
    },
    methods: {
        showUploadButtonVisibility(){
            var navID = (this.navMenuID!= -1? this.navMenuID : sessionStorage.NavMenuID);
            axios
                .get(sessionStorage.apiUrl + '/Uploader/GetTemplateDetails?navMenuID=' + navID)
                .then(response => {
                    this.showUploadButton = response.data;
                })
                .catch(error => {
                    console.log(error);
                    this.showUploadButton = false;
                })
        },
        clearSearchText() {
            var xButton = this.$refs["searchClearButton-" + this.widgetid];
            xButton.style.display = "none";
            this.searchBoxIsEmpty = true;
            this.debouncedSearch = "";           
            this.search = "";

            var inputElement = this.$refs["searchP4-" + this.widgetid];
            if(inputElement === undefined) {
                return;
            }
            
            var searchBox = {};
            if(inputElement !== undefined)
            {
                var elms = inputElement.$el.getElementsByTagName("*");
                for (var i = 0; i < elms.length; i++) {    
                    if(elms[i].tagName === "INPUT" && (elms[i].id === "searchP4" || elms[i].id === "searchNonEmpty"))
                    {
                        searchBox = elms[i];
                    }
                }
            }

            if(searchBox !== null && JSON.stringify(searchBox) !== "{}")
            {
                searchBox.id = "searchP4";
                searchBox.classList.remove("searchfocus");
                searchBox.focus();
            }

            var clearInputElement = this.$refs["searchP4-" + this.widgetid];
            clearInputElement.clearSearch();
        },
        showTextField() {
            window.Bus.$emit("clickedSearch");
        },
        emitMouseOut(e) {
            window.Bus.$emit("mousedout",e);
        },
        emitToolTipClose() {
            window.Bus.$emit("tooltipClose");
        },
        emitNavigateBackEvent() {
            this.$emit("navigate-back-event");
        },
        emitSearchEvent(val) {
            this.$emit("search-event", this.search);
        },
        emitSaveEvent() {
            this.$emit("save-event");
            this.emitToolTipClose();
            $(".circle").show();
        },
        emitCheckEvent() {
            this.$emit("check-event");
        },
        emitRefreshEvent() {
            window.Bus.$emit("DataRefreshEvent");
            this.$emit("refresh-event");
            $(".circle").show();
        },
        emitAddEvent() {
            this.$emit("add-event");
            this.emitToolTipClose();
            // When the add button is pressed, set frozen headers to freeze the header only. Otherwise the UI gets confusing.
            window.Bus.$emit("freezeTop");
        },
        emitEllipsisEvent() {
            this.$emit("ellipsis-event");
            this.emitToolTipClose();
        },
        emitCloseEvent() {
            this.$emit("close-event");
        },
        emitUploadEvent(){
            this.$emit("upload-event");
        },
        emitExcelEvent(){
            this.$emit("excel-event");
        }
    }
};
</script>
<style lang='scss'>
    @import "../styles/p4vuetify.scss";
    @import "../styles/ps-report-header.scss";
</style>